export const industryNameMaxLength = 100;
export const errorMessage = `Industry name cannot exceed ${industryNameMaxLength} characters`;
